module.exports = __webpack_public_path__ + "static/SectionOne-049eaa419c67669cb81d1ca9acc78921.png";